import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { colors } from '../../../constants/colors';

const ZeroHitTrendsChart = ({ data = [], isLoading = false }) => {
  // Handle different possible data structures from API
  const chartData = data.map((item, index) => ({
    date: item.date ? new Date(item.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : 
          item.month ? item.month : 
          item.period || `Period ${index + 1}`,
    zeroHits: item.zeroHits || item.zero_hits || item.count || item.value || 0,
    totalQueries: item.totalQueries || item.total_queries || item.total || item.queries || 0,
    percentage: (item.totalQueries || item.total_queries || item.total || item.queries || 0) > 0 ? 
                (((item.zeroHits || item.zero_hits || item.count || item.value || 0) / (item.totalQueries || item.total_queries || item.total || item.queries || 0)) * 100).toFixed(1) : 0
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{
          backgroundColor: colors.background.primary,
          border: `1px solid ${colors.border}`,
          borderRadius: '6px',
          padding: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <p style={{ 
            margin: '0 0 4px 0', 
            fontWeight: '600', 
            color: colors.text.primary,
            fontSize: '14px'
          }}>
            Date: {label}
          </p>
          <p style={{ 
            margin: '0 0 2px 0', 
            color: colors.text.secondary,
            fontSize: '12px'
          }}>
            Zero Hits: {data.zeroHits}
          </p>
          <p style={{ 
            margin: '0 0 2px 0', 
            color: colors.text.secondary,
            fontSize: '12px'
          }}>
            Total Queries: {data.totalQueries}
          </p>
          <p style={{ 
            margin: 0, 
            color: colors.text.secondary,
            fontSize: '12px'
          }}>
            Zero Hit Rate: {data.percentage}%
          </p>
        </div>
      );
    }
    return null;
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        color: colors.text.secondary
      }}>
        Loading...
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        color: colors.text.secondary
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>📈</div>
        <p style={{ margin: 0, fontSize: '16px' }}>No trend data available</p>
        <p style={{ margin: '4px 0 0 0', fontSize: '14px' }}>Start using the system to see trends</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={colors.border} />
        <XAxis 
          dataKey="date" 
          stroke={colors.text.secondary}
          fontSize={12}
        />
        <YAxis 
          stroke={colors.text.secondary}
          fontSize={12}
        />
        <Tooltip content={<CustomTooltip />} />
        <Line 
          type="monotone" 
          dataKey="zeroHits" 
          stroke={colors.status.error}
          strokeWidth={3}
          dot={{ fill: colors.status.error, strokeWidth: 2, r: 4 }}
          activeDot={{ r: 6, stroke: colors.status.error, strokeWidth: 2 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ZeroHitTrendsChart;

